export const cvvSecurityCodeToggle = () => {
  const closeWhatsThis = (popoverLink) => {
    if ($('.popover .close').length === 0) {
      $('.popover').prepend('<button type="button" class="close" data-dismiss="popover"><span aria-hidden="true">×</span></button>');
      $('.popover .close').on('click.closeCvv', function () {
        $(popoverLink).trigger('click');
        $('.cvv-bg').remove();
      });
    };
  }
  const toggleWhatsThis = (popoverLink) => {
    $(popoverLink).on('click.asd', function () {
      if ($('.cvv-bg').length > 0) {
        $('.cvv-bg').remove();
      } else {
        $('body').append('<div class="modal-backdrop fade in cvv-bg"></div>');
        $('.cvv-bg').on('touchstart, click.removeCvvBg', function () {
          $(popoverLink).trigger('click');
        });
        setTimeout(function () {
          closeWhatsThis(popoverLink);
        }, 400);
      };
    });
  }
  toggleWhatsThis('#qcProfile2 #cvn-what');
  toggleWhatsThis('#newCards2 #cvn-what');
  toggleWhatsThis('#gcpin-what');
};
